<template>
  <div id="snackbar" class="uk-flex toast">
    <div class="left-blue-tile"></div>
    <div class="img-container"><img :src="url"></div>
    <div class="text">
      {{message}}
    </div>
    <div class="button-container">
      <button class="close-button" @click="closeToast">{{$t('general.gotIt')}}</button>
    </div>
  </div>
</template>

<script>
  import * as misc from '../../../enums/misc'
  import iconUtil from '../../../utils/icon-util'

  export default {
    name: 'success-toast',
    props: ['success', 'message', 'duration'],
    data() {
      return {
        url: iconUtil.resolve(misc.SUCCESS_TOAST)
      }
    },
    methods: {
      show() {
        let x = document.getElementById('snackbar')
        x.className = 'show'
      },
      closeToast() {
        let x = document.getElementById('snackbar')
        x.className = x.className.replace('show', '')
      }
    },
    watch: {
      success(value) {
        if (value) {
          this.show()
        }
      }
    },
    mounted() {
      if (this.success) {
        this.show()
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../../../src/styles/colours';
  @import '../../../../src/styles/breakpoints';

  .toast {
    margin: 0px auto;
    left: 0px;
    right: 0px;
  }

  .left-blue-tile {
    width: 16px;
    height: 80px;
    border-radius: 2px;
    background-color: $light-blue;
  }

  .img-container {
    height: 65px;
    width: 65px;
    position: absolute;
    bottom: 0px;
    margin-left: 23px;
    padding-bottom: 8px;
  }

  .text {
    width: 700px;
    height: 40px;
    padding: 20px 0 20px 0;
    position: absolute;
    margin-left: 108px;
    bottom: 0px;
    font-size: 18px;
  }

  .close-button {
    width: 152px;
    height: 44px;
    border-radius: 2px;
    box-shadow: 0 1px 3px 0 $drop-shadow-black;
    border: solid 2px $light-blue;
    background-color: $light-blue;
    position: absolute;
    bottom: 0px;
    color: white;
    font-size: 18px;
    font-weight: bold;
    margin: 18px 18px 18px -160px;
    &:hover {
      box-shadow: 3px 5px 8px 0 $drop-shadow-black;
      border: solid 2.8px white;
      background-color: white;
      color: $light-blue;
    }
  }

  .button-container {
    float: right;
  }

  #snackbar {
    width: 1044px;
    visibility: hidden;
    background-color: white;
    color: black;
    border-radius: 2px;
    position: fixed;
    z-index: 1;
    bottom: 25px;
    height: 80px;
    padding: 0px;
    box-shadow: 0 1px 3px 0 $drop-shadow-black, 3px 5px 8px 0 $drop-shadow-black;
  }

  #snackbar.show {
    visibility: visible;
    -webkit-animation: fadein 1s;
    animation: fadein 1s;
    margin: 0px auto;
    left: 0px;
    right: 0px;
  }

  @-webkit-keyframes fadein {
    from {
      bottom: 0;
      opacity: 0;
    }
    to {
      bottom: 25px;
      opacity: 1;
    }
  }

  @keyframes fadein {
    from {
      bottom: 0;
      opacity: 0;
    }
    to {
      bottom: 25px;
      opacity: 1;
    }
  }

  @-webkit-keyframes fadeout {
    from {
      bottom: 25px;
      opacity: 1;
    }
    to {
      bottom: 0;
      opacity: 0;
    }
  }

  @keyframes fadeout {
    from {
      bottom: 25px;
      opacity: 1;
    }
    to {
      bottom: 0;
      opacity: 0;
    }
  }

  @media screen and (max-width: $breakpoint-medium) {
    .text {
      width: 450px;
    }
    #snackbar {
      width: 700px;
    }
    .close-button {
      font-size: 16px;
      width: 122px;
      height: 44px;
      margin: 18px 18px 18px -140px;
    }
  }
</style>
